/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { BLoCBase } from "./classes/BLoCBase";
import { IBLoC } from "./types/IBLoC";
import { Observable } from "rxjs";

export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};

export const useInitBLoC = <T extends IBLoC & BLoCBase<any>>(
  getBloc: () => T | null | undefined,
  params: any[] = [],
) => {
  const isFirstRunMem = useRef<any[] | null>(null);

  const [bloc, setBloc] = useState<T | null>(null);
  /* work around for React's debug strict mode that calls all hooks twice. */
  useEffect(() => {
    if (
      !isFirstRunMem.current ||
      isFirstRunMem.current.length !== params.length ||
      isFirstRunMem?.current?.filter((c, i) => params[i] !== c).length
    ) {
      isFirstRunMem.current = params;
      const newB = getBloc() || null;
      newB &&
        Object.keys(newB).forEach(
          (key) =>
            newB[key as never] &&
            !["subs", "state"].includes(key) &&
            !((newB[key as never] as any) instanceof Observable) &&
            !((newB[key as never] as any) instanceof Function) &&
            !(newB[key as never] as any)?.watch &&
            Object.freeze(newB[key as never]),
        );
      setBloc(newB ? Object.freeze(newB) : null);
      return;
    }
  }, [getBloc, ...params]);
  useEffect(() => {
    bloc?.onInit && bloc.onInit();
    return () => {
      bloc?.unsub && bloc.unsub();
      bloc?.onDestroy && bloc.onDestroy();
      bloc?.onDestroyBase && bloc.onDestroyBase();
    };
  }, [bloc]);
  return bloc as Readonly<T>;
};
